import devEnvConfig from "./dev.json";
import localEnvConfig from "./local.json";
import prodEnvConfig from "./prod.json";
import stagingEnvConfig from "./staging.json";

const getEnvironmentConfig = () => {
  const env = process.env.REACT_APP_BUILD_ENV || "development";
  switch (env) {
    case "production":
      return prodEnvConfig;
    case "local":
      return localEnvConfig;
    case "staging":
      return stagingEnvConfig;
    default:
      return devEnvConfig;
  }
};

export const environmentConfig = getEnvironmentConfig();
